/** @format */

import {
  HomrBundleSpot,
  HomrGTGTContent,
  HomrScheduleContent,
  IHomrBanner,
  IHomrRichContent,
  IHomrSpot,
} from '@shared/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

import { HomrInStoreServices } from '@shared/homr/data-access';

export const setHomrScheduleContent = createAction(
  '[Homr] Set Homr Schedule Content',
  props<{ homrScheduleContent: HomrScheduleContent }>(),
);

export const setHomrGTGTContent = createAction(
  '[Homr] Set Homr GTGT Content',
  props<{ homrGTGTContent: HomrGTGTContent }>(),
);

export const homrBannerSet = createAction(
  '[Homr] Homr Banner Set',
  props<{ homrBanner: IHomrBanner }>(),
);

export const homrBundleContentSet = createAction(
  '[Homr] Homr Bundle Content Set',
  props<{ homrBundleContent: HomrBundleSpot }>(),
);

export const homrContentSet = createAction(
  '[Homr] Homr Content Set',
  props<{ homrContent: IHomrSpot[] }>(),
);

export const homrInStoreServicesSet = createAction(
  '[Homr] Homr In Store Services Set',
  props<{ homrInStoreServices: HomrInStoreServices }>(),
);

export const homrRichContentSet = createAction(
  '[Homr] Homr Rich Content Set',
  props<{ homrRichContent: IHomrRichContent }>(),
);

export const homrStateReset = createAction('[Homr] Homr State Reset');
